/**
 * Study-minute figures for the Engagement view. The API sends `avg_study_minutes_7d` and
 * `avg_study_minutes_30d` as per-student TOTALS over their windows, so they only compare once
 * they are turned into per-day averages.
 */

/** Per-student minutes per day for a window total. */
export function perDay(total: number, days: number): number {
  return days > 0 ? total / days : 0;
}

/** % change of the 7-day daily average against the 30-day daily average; null with no 30-day baseline. */
export function studyDelta7vs30(avg7Total: number, avg30Total: number): number | null {
  const base = perDay(avg30Total, 30);
  if (base <= 0) return null;
  return ((perDay(avg7Total, 7) - base) / base) * 100;
}

/** Days with fewer active students than this share of the busiest day are drawn in the accent colour. */
export const LOW_DAY_SHARE = 0.6;

export function isLowDay(count: number, max: number): boolean {
  return max > 0 && count < max * LOW_DAY_SHARE;
}
